var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.appNowPaySchemeShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          { staticClass: "content", attrs: { id: "appNowPayScheme" } },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\r\n              " +
                  _vm._s(
                    _vm.$t("language.popup.upgradeAccountPopup.currentPlan")
                  ) +
                  "\r\n            "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    _vm.appNowPaySchemeShow = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "app-now-scheme-body" }, [
              _c("div", { staticClass: "app-now-scheme-mid" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.payInfo.type == "ios",
                        expression: "payInfo.type=='ios'"
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "app-now-scheme-tips" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.paySystem.nowPayScheme.appleTip", {
                            name: _vm.payInfo.name
                          })
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "app-now-scheme-tips" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.paySystem.nowPayScheme.appleTipId", {
                            id: _vm.payInfo.transactionId
                          })
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.payInfo.type == "google",
                        expression: "payInfo.type=='google'"
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "app-now-scheme-tips" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.paySystem.nowPayScheme.googleTip", {
                            name: _vm.payInfo.name
                          })
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "app-now-scheme-tips" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.nowPayScheme.googleTipId",
                            { id: _vm.payInfo.transactionId }
                          )
                        )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "app-now-scheme-mid" }, [
                _c("div", { staticClass: "app-now-scheme-tips" }, [
                  _vm.payInfo.isSubscribe
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.paySystem.nowPayScheme.appNextTimeTip",
                              { time: _vm.payInfo.nextTime }
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.payInfo.isSubscribe
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.paySystem.nowPayScheme.appNoSubscribe"
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "app-now-scheme-close" }, [
                _c(
                  "button",
                  {
                    staticStyle: { "border-radius": "5Px" },
                    on: {
                      click: function($event) {
                        _vm.appNowPaySchemeShow = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d719f1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d719f1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/pay_system_popups/app_now_pay_scheme_popups.vue
// module id = null
// module chunks = 